<template>
  <div class="base-question-wrapper">
    <div :class="['title', { 'is-detail': isDetail }, { 'is-first': index === 0 }]">
      <div v-if="!isDetail && questionData.questionType === 2" class="type-tag">多选</div>
      <template v-if="isDetail">{{ index + 1 }}.&nbsp;</template>{{ questionData.questionTitle }}
      <span v-if="questionData.answerType === 2 && !isDetail" class="optional">选填</span>
    </div>
    <div :id="'scrollArea' + questionData.questionId" :class="{'scroll-area-wrapper': !isDetail}">
      <div v-if="questionData.diagramDesc" class="sub-title">{{ questionData.diagramDesc }}</div>
      <div v-if="questionData.diagramUrl" :class="['demo-image', {'has-desc': questionData.diagramDesc}]">
        <img :src="questionData.diagramUrl" />
      </div>
      <div :class="['ques-slot', { 'is-detail': isDetail }]">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { skipToDefault } from '../../helper';

export default {
  name: 'BaseQuestion',
  props: {
    questionData: {
      type: Object,
      default() {}
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    }
  },
  watch: {
    'skipToDefault.change'(val) {
      if (val) {
        const data = skipToDefault.value;
        const parentRef = document.getElementById('scrollArea' + data.parent.questionId);
        const top = document.getElementById(data.detail?.answerId + '')?.offsetTop;

        if (data.parent.questionType !== 3) {
          skipToDefault.value.change = false;
          this.$nextTick(() => {
            parentRef.scrollTop = top - parentRef.offsetTop - 20;
          });
        } 
      }
    }
  },
  data() {
    return {
      skipToDefault: skipToDefault
    };
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.base-question-wrapper {
  .title {
    font-weight: 500;
    font-size: 32px;
    color: #3A3B3C;
    line-height: 40px;
    // display: flex;
    // align-items: center;
    // flex-wrap: wrap;
    .type-tag {
      float: left;
      border-radius: 22px;
      border: 2px solid rgba(255,88,62,0.3);
      font-weight: 500;
      font-size: 22px;
      color: #FF583E;
      // display: inline-block;
      padding: 8px 12px;
      margin-top: -4px;
      margin-right: 8px;
      line-height: 24px;
    }
    .optional {
      font-weight: 400;
      font-size: 28px;
      color: #ACACAC;
    }
    &.is-detail {
      color: #89898A;
      font-weight: 400;
      margin-top: 40px;
    }
  }
  .sub-title {
    font-size: 24px;
    color: #ACACAC;
    line-height: 35px;
    margin-top: 20px;
    margin-bottom: 16px;
  }
  .demo-image {
    margin-top: 16px;
    &.has-desc {
      margin-top: 0;
    }
  }
  .demo-image img{
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
  }
  .scroll-area-wrapper {
    overflow: auto;
    max-height: 43vh;
  }
  .ques-slot {
    padding-bottom: 32px;
    &.is-detail {
      padding-bottom: unset;
    }
  }
}
</style>
